import styled from '@emotion/styled';

const profilePrimary = 'var(--profile-primary, #6025D8)';
const profilePrimaryDark = 'var(--profile-primary-dark, #4c1dab)';
const profilePrimaryMuted = 'var(--profile-primary-muted, rgba(96, 37, 216, 0.1))';
const profileOnPrimary = 'var(--profile-on-primary, #ffffff)';

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    @media (max-width: 640px) {
        flex-direction: column-reverse;
    }
`;

const ActionButton = styled.button`
    height: 40px;
    padding: 0 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.65;
    }
`;

export const SecondaryButton = styled(ActionButton)`
    border: 1px solid #e2e8f0;
    background: #ffffff;
    color: #334155;

    &:hover:not(:disabled) {
        border-color: ${profilePrimary};
        background: ${profilePrimaryMuted};
        color: ${profilePrimary};
    }

    &:focus-visible {
        outline: 2px solid ${profilePrimary};
        outline-offset: 2px;
    }
`;

export const PrimaryButton = styled(ActionButton)`
    border: none;
    background: ${profilePrimary};
    color: ${profileOnPrimary};

    &:hover:not(:disabled) {
        background: ${profilePrimaryDark};
    }

    &:focus-visible {
        outline: 2px solid ${profilePrimary};
        outline-offset: 2px;
    }
`;
